import { useMemo } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { type Draft, useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';
import { useTrackView } from '#src/app/shared/hooks/tracking';

import { replaceAllValuesWithTrueRecord } from './utils';

type GetterFn = (draft?: Draft | null) => Record<string, unknown>;
type TrackingData = Readonly<Record<string, GetterFn | undefined>>;
const TRACKING_DATA: TrackingData = {
	recommendations: (draft) => ({
		ai_recommended_angles:
			draft?.input?.recommendations?.map(({ recommendation, why }, index) => ({
				position: index + 1,
				recommendation,
				why,
			})) ?? [],
	}),
};

export function useTrackPageView(): void {
	const { step } = useKnownAvailableParams<{ step: string }>();
	const { data } = useStartAPetitionPageState();
	const loginMethod = data.draft?.metadata?.user?.loginOrJoinMethod;

	const formattedStep = useMemo(() => step.replace(/-/g, '_').toLowerCase(), [step]);
	const stepData = TRACKING_DATA[formattedStep]?.(data.draft) ?? {};
	const draftData = replaceAllValuesWithTrueRecord(data.draft ?? {});

	useTrackView(`sap_${formattedStep}_view`, { ...stepData, login_method: loginMethod, draft: draftData });
}
